module.exports = __webpack_public_path__ + "img/12876c3.jpg";